<template>
  <div class="sidebar-nav">
    <transition name="sidebar-drill" mode="out-in">
      <ul
        v-if="!drillParent"
        key="main"
        class="app-sidebar__list list-unstyled mb-0"
      >
        <li class="app-sidebar__item">
          <router-link
            v-tooltip.right="sidebarTip('Dashboard')"
            to="/dashboard"
            class="app-sidebar__link app-sidebar__link--pill"
            @click="emitNavigated"
          >
            <i class="fa fa-home app-sidebar__icon" aria-hidden="true" />
            <span class="app-sidebar__label">Dashboard</span>
          </router-link>
        </li>
        <li class="app-sidebar__item">
          <router-link
            v-tooltip.right="sidebarTip('Calendar')"
            to="/calendar"
            class="app-sidebar__link app-sidebar__link--pill"
            @click="emitNavigated"
          >
            <i class="fa fa-calendar app-sidebar__icon" aria-hidden="true" />
            <span class="app-sidebar__label">Calendar</span>
          </router-link>
        </li>
        <li
          class="app-sidebar__item"
          v-if="$isAdmin() && $can('clients', 'view')"
        >
          <router-link
            v-tooltip.right="sidebarTip($filters.customerLabel('plural', true))"
            :to="{ name: 'patients' }"
            class="app-sidebar__link app-sidebar__link--pill"
            :class="{
              'router-link-active': $route.path.startsWith('/clients'),
            }"
            @click="emitNavigated"
          >
            <i class="fa fa-users app-sidebar__icon" aria-hidden="true" />
            <span class="app-sidebar__label">{{
              $filters.customerLabel("plural", true)
            }}</span>
          </router-link>
        </li>
        <li class="app-sidebar__item">
          <router-link
            v-tooltip.right="sidebarTip($filters.providerLabel('plural', true))"
            :to="{ name: 'providers' }"
            class="app-sidebar__link app-sidebar__link--pill"
            :class="{
              'router-link-active': $route.path.startsWith('/providers'),
            }"
            @click="emitNavigated"
          >
            <i class="fa fa-user-md app-sidebar__icon" aria-hidden="true" />
            <span class="app-sidebar__label">{{
              $filters.providerLabel("plural", true)
            }}</span>
          </router-link>
        </li>
        <li class="app-sidebar__item">
          <router-link
            v-tooltip.right="sidebarTip('Tasks')"
            to="/tasks"
            class="app-sidebar__link app-sidebar__link--pill"
            :class="{ 'router-link-active': $route.path.startsWith('/tasks') }"
            @click="emitNavigated"
          >
            <i class="fa fa-tasks app-sidebar__icon" aria-hidden="true" />
            <span class="app-sidebar__label">Tasks</span>
          </router-link>
        </li>
        <li class="app-sidebar__item">
          <button
            v-tooltip.right="sidebarTip('My Profile')"
            type="button"
            class="
              app-sidebar__link
              app-sidebar__link--pill
              app-sidebar__link--parent
              w-100
              text-left
            "
            @click="openDrill('profile')"
          >
            <i class="fa fa-user app-sidebar__icon" aria-hidden="true" />
            <span class="app-sidebar__label">My Profile</span>
            <i
              class="fa fa-chevron-right app-sidebar__chevron"
              aria-hidden="true"
            />
          </button>
        </li>
      </ul>
      <ul
        v-else-if="drillParent === 'profile'"
        key="profile"
        class="app-sidebar__list list-unstyled mb-0"
      >
        <li class="app-sidebar__item">
          <a
            href="/"
            class="app-sidebar__link app-sidebar__link--pill"
            @click.prevent="profileNavigate"
          >
            <span class="app-sidebar__label">Profile Update</span>
          </a>
        </li>
        <li class="app-sidebar__item">
          <a
            href="#"
            class="app-sidebar__link app-sidebar__link--pill"
            @click.prevent="handleLogout"
          >
            <span class="app-sidebar__label">Logout</span>
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "SidebarNavReferral",
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["drill-change", "navigated"],
  data() {
    return {
      drillParent: null,
      suppressRouteSync: false,
    };
  },
  watch: {
    $route: {
      handler() {
        this.suppressRouteSync = false;
        this.applyRouteToDrill();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      deviceType: (state) => state.settings.deviceType,
    }),
    isMobileTablet() {
      return this.deviceType === "mobile" || this.deviceType === "tablet";
    },
  },
  methods: {
    ...mapActions({
      doLogout: "auth/logout",
    }),
    sidebarTip(text) {
      if (!this.collapsed || this.isMobileTablet) return false;
      return text;
    },
    computeDrillFromPath() {
      return null;
    },
    applyRouteToDrill() {
      if (this.suppressRouteSync) return;
      if (this.collapsed && !this.isMobileTablet) {
        this.drillParent = null;
        this.emitDrillState(false);
        return;
      }
      this.drillParent = this.computeDrillFromPath();
      this.emitDrillState(false);
    },
    openDrill(key) {
      this.suppressRouteSync = false;
      this.drillParent = key;
      this.emitDrillState(true);
    },
    goBackDrill() {
      this.suppressRouteSync = true;
      this.drillParent = null;
      this.emitDrillState(false);
    },
    emitDrillState(userInitiated = false) {
      if (!this.drillParent) {
        this.$emit("drill-change", {
          showBack: false,
          title: "",
          userInitiated: !!userInitiated,
        });
        return;
      }
      this.$emit("drill-change", {
        showBack: true,
        title: "My Profile options",
        userInitiated: !!userInitiated,
      });
    },
    emitNavigated() {
      this.$emit("navigated");
    },
    profileNavigate() {
      this.$router.push({ path: "/dashboard" });
      this.emitNavigated();
    },
    handleLogout() {
      this.doLogout().then((res) => {
        if (res) {
          this.$router.push({ path: "/login" });
          window.location.href = `${window.location.origin}`;
        }
      });
    },
  },
};
</script>
